import React, {
    useContext,
    useState,
    useEffect,
} from 'react';
import { useMutation } from '@tanstack/react-query';

import { getBasketData, refetchBasketData, NotificationContext, handleError } from '../router'

import * as OPTIONS from "../option-fields";
import * as QUERIES from "../query-functions";
import LoadingIndicator from '../components/loading-indicator';

const fundId = OPTIONS.donationUpsell.fund?.innerHTML;
const donationRules = OPTIONS.donationUpsell.amounts && JSON.parse(OPTIONS.donationUpsell.amounts);
let donationAutoAdded = false;
let doNotDonateClicked = false;

export default function DonationPrompt(props) {

    const {notification, setNotification} = useContext(NotificationContext);
    const { data: basketData, isPending: basketDataPending, isFetching: basketDataFetching } = getBasketData();

    const [donationAmount, setDonationAmount] = useState(null);
    const [donationId, setDonationId] = useState(null);
    const [pending, setPending] = useState(false);

    const addDonation = useMutation({
        mutationFn: () => QUERIES.addDonation([{Amount: donationAmount, FundId: fundId}]),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: (data) => {
            refetchBasketData();
        },
    });

    const removeDonation = useMutation({
        mutationFn: () => QUERIES.removeDonation([donationId]),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: (data) => {
            refetchBasketData();
        },
    });

    useEffect(() => {
        if (!basketData) return;
        setPending(true);

        // Find out if donation is already in the basket
        // If it is assign the basket id so it can be removed by the user
        const donation_in_basket = basketData.donations?.find((donation) => donation.fund?.id == fundId);
        
        if (donation_in_basket) {
            setDonationId(donation_in_basket.id);
            setDonationAmount(donation_in_basket.amount);

            // If a donation is already in the basket exit before checking donation rules
            setPending(false);
            return;
        }
        
        // If there is no donation in basket continue to work out donation amount
        setDonationId(null);

        // Check if basket total is within bounds to display prompt
        const basket_total = basketData.total;
        let donationAmount = null;

        for (const rule of donationRules) {
            const from = parseFloat(rule.from);
            const to = parseFloat(rule.to);

            if (basket_total >= from && basket_total <= to) {
                donationAmount = parseFloat(rule.donation);
                break;
            }
        }

        // Now decide to show the prompt
        if (donationAmount !== null) {
            setDonationAmount(donationAmount);
        }

        setPending(false);
    }, [basketData])

    useEffect(() => {
        if (!donationAmount || doNotDonateClicked) return;

        if (!donationAutoAdded && !donationId) {
            donationAutoAdded = true;
            addDonation.mutateAsync();
        }

    }, [donationAmount])

    if (!fundId || !basketData || pending) return;

    if (addDonation.isPending || removeDonation.isPending || basketDataFetching) return <LoadingIndicator />;

    return (
        <section className='donation-prompt'>
            <h2 className='booking-pathway__header'>{OPTIONS.donationUpsell.title?.innerHTML}</h2>
            <div className='donation-prompt--description' dangerouslySetInnerHTML={{__html: OPTIONS.donationUpsell.introduction?.innerHTML}}></div>
            <p className={`donation-prompt--detail ${donationId ? 'donation-added' : 'donation-removed' }`}>
                <span>Donation</span>
                <span>£{donationAmount}</span>
            </p>
            {donationId ?
                <button type="button" className='donation-prompt--button' onClick={() => {doNotDonateClicked = true; removeDonation.mutateAsync()}}>I do not wish to donate</button>
            :    
                <button type="button" className='donation-prompt--button' onClick={() => addDonation.mutateAsync()}>I'd like to donate</button>
            }
        </section>
    );
}